import { version2Stores } from "./v2";

/**
 * No indexes changed. Advancing the IndexedDB version closes pre-measure app
 * clients so their older record mappers cannot overwrite the new embedded
 * measure and portion-display fields.
 */
export const version3Stores = { ...version2Stores } as const;
